import script from "./BssMovementToggleListButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BssMovementToggleListButton.vue?vue&type=script&lang=ts&setup=true"

import "./BssMovementToggleListButton.vue?vue&type=style&index=0&id=48c28061&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c28061"]])

export default __exports__